import React, { Component } from 'react'
import styles from './style.module.less'
import Panel from '@common/Panel'
import api from '@api/home'
import auth, { PLATFORM_ACTIVITY } from '../auth'
import { Link } from 'react-router'

/** 平台活动 */
@auth(PLATFORM_ACTIVITY)
export default class extends Component {
  state = {
    data: {}
  }
  async componentDidMount() {
    const { success, data } = await api.getPlatformActivityApi()
    let _data = {}
    if (success) {
      _data = data || {}
    }
    this.setState({
      data: _data
    })
  }
  render() {
    const { title, abstract, img, apply_end_time, id } = this.state.data
    const end = (apply_end_time || '').split(' ')[0]
    return (
      !!title && (
        <Panel
          title="平台活动"
          action={<a href={'#/localMerchant/activityRegister'}>更多</a>}
          contentStyle={{ padding: 0 }}
        >
          <Link to={`/localMerchant/activityRegister/activityDetail/${id}`}>
            <div className={styles.content}>
              <div className={styles.main}>
                <img src={`${img}?imageView2/2/w/144/h/112`} alt="活动封面" />
                <div className={styles.right}>
                  <div className={styles.title}>{title}</div>
                  <div className={styles.detail}>{abstract}</div>
                </div>
              </div>
              <div className={styles.date}>截止至 {end}</div>
            </div>
          </Link>
        </Panel>
      )
    )
  }
}
